/* @flow */
'use strict';
/* :: import type {Batch, Query, QueryResult, Callback} from './' */

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var pull = require('pull-stream');

var setImmediate = require('async/setImmediate');

var asyncFilter = require('./utils').asyncFilter;

var asyncSort = require('./utils').asyncSort;

var Key = require('./key'); // Errors


var Errors = require('./errors');

var MemoryDatastore =
/*#__PURE__*/
function () {
  /* :: data: {[key: string]: Buffer} */
  function MemoryDatastore() {
    _classCallCheck(this, MemoryDatastore);

    this.data = {};
  }

  _createClass(MemoryDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      setImmediate(callback);
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , val
    /* : Buffer */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.data[key.toString()] = val;
      setImmediate(callback);
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Buffer> */
    )
    /* : void */
    {
      var _this = this;

      this.has(key, function (err, exists) {
        if (err) {
          return callback(err);
        }

        if (!exists) {
          return callback(Errors.notFoundError());
        }

        callback(null, _this.data[key.toString()]);
      });
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      var _this2 = this;

      setImmediate(function () {
        callback(null, _this2.data[key.toString()] !== undefined);
      });
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      delete this.data[key.toString()];
      setImmediate(function () {
        callback();
      });
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Buffer> */
    {
      var _this3 = this;

      var puts = [];
      var dels = [];
      return {
        put: function put(key
        /* : Key */
        , value
        /* : Buffer */
        )
        /* : void */
        {
          puts.push([key, value]);
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          dels.push(key);
        },
        commit: function commit(callback
        /* : Callback<void> */
        )
        /* : void */
        {
          puts.forEach(function (v) {
            _this3.data[v[0].toString()] = v[1];
          });
          puts = [];
          dels.forEach(function (key) {
            delete _this3.data[key.toString()];
          });
          dels = [];
          setImmediate(callback);
        }
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Buffer> */
    )
    /* : QueryResult<Buffer> */
    {
      var _this4 = this;

      var tasks = [pull.keys(this.data), pull.map(function (k) {
        return {
          key: new Key(k),
          value: _this4.data[k]
        };
      })];
      var filters = [];

      if (q.prefix != null) {
        var prefix = q.prefix;
        filters.push(function (e, cb) {
          return cb(null, e.key.toString().startsWith(prefix));
        });
      }

      if (q.filters != null) {
        filters = filters.concat(q.filters);
      }

      tasks = tasks.concat(filters.map(function (f) {
        return asyncFilter(f);
      }));

      if (q.orders != null) {
        tasks = tasks.concat(q.orders.map(function (o) {
          return asyncSort(o);
        }));
      }

      if (q.offset != null) {
        var i = 0; // $FlowFixMe

        tasks.push(pull.filter(function () {
          return i++ >= q.offset;
        }));
      }

      if (q.limit != null) {
        tasks.push(pull.take(q.limit));
      }

      if (q.keysOnly === true) {
        tasks.push(pull.map(function (e) {
          return {
            key: e.key
          };
        }));
      }

      return pull.apply(null, tasks);
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      setImmediate(callback);
    }
  }]);

  return MemoryDatastore;
}();

module.exports = MemoryDatastore;